import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "../config";

const EASE = [0.16, 1, 0.3, 1];
const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.7, ease: EASE },
};

function ImageCard({ span, img, tag, title, desc, alt }) {
  return (
    <motion.article
      {...reveal}
      className={`group relative overflow-hidden border border-white/10 ${span} h-[420px] md:h-[480px]`}
    >
      <img
        src={img}
        alt={alt}
        className="absolute inset-0 h-full w-full object-cover opacity-50 transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.85) 100%)",
        }}
      />
      <div className="absolute inset-x-0 bottom-0 p-7 md:p-9">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">
          {tag}
        </p>
        <h3 className="mt-3 font-display text-2xl font-black uppercase tracking-tight text-white md:text-4xl">
          {title}
        </h3>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-white/65 md:text-base">
          {desc}
        </p>
      </div>
    </motion.article>
  );
}

function TextCard({ span, tag, title, desc, invert }) {
  return (
    <motion.article
      {...reveal}
      className={`flex flex-col justify-between p-7 transition-transform duration-300 hover:-translate-y-1 md:p-9 ${span} ${
        invert
          ? "bg-white text-black"
          : "border border-white/10 bg-card text-white"
      }`}
    >
      <div>
        <p
          className={`font-mono text-[10px] uppercase tracking-[0.3em] ${
            invert ? "text-black/50" : "text-white/50"
          }`}
        >
          {tag}
        </p>
        <h3 className="mt-3 font-display text-2xl font-black uppercase tracking-tight md:text-4xl">
          {title}
        </h3>
        <p
          className={`mt-3 max-w-md text-sm leading-relaxed md:text-base ${
            invert ? "text-black/65" : "text-white/65"
          }`}
        >
          {desc}
        </p>
      </div>
      <ArrowUpRight
        className={`mt-8 h-8 w-8 ${invert ? "text-black" : "text-white/30"}`}
      />
    </motion.article>
  );
}

export default function Services() {
  return (
    <section id="consultoria" className="section-pad">
      <div className="container-x">
        <motion.div {...reveal} className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="overline-label">A consultoria</p>
            <h2 className="h2-display mt-4 text-white">
              Treino + dieta,
              <br />
              <span className="text-stroke">sem atalhos.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-white/55 md:text-base">
            Quatro pilares que sustentam a sua transformação — cada protocolo
            é construído do zero para o seu corpo e a sua rotina.
          </p>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 gap-4 lg:grid-cols-12">
          <ImageCard
            span="lg:col-span-7"
            img={IMAGES.training}
            alt="Atleta levantando barra no escuro"
            tag="Pilar 01"
            title="Treinamento personalizado"
            desc="Fichas completas com execução em vídeo, divisão sob medida (PPL, Upper/Lower, ABC), progressão de carga estruturada e ajustes semanais."
          />
          <ImageCard
            span="lg:col-span-5"
            img={IMAGES.nutrition}
            alt="Alimento preparado em panela sobre fundo escuro"
            tag="Pilar 02"
            title="Nutrição & plano alimentar"
            desc="Dieta flexível calculada grama por grama para os seus macros, com substituições inteligentes que cabem na sua rotina."
          />
          <TextCard
            span="lg:col-span-5"
            invert
            tag="Pilar 03"
            title="Acompanhamento 1:1 no WhatsApp"
            desc="Canal direto comigo para dúvidas de execução, substituições de refeições e suporte motivacional — resposta em até 24h."
          />
          <TextCard
            span="lg:col-span-7"
            tag="Pilar 04"
            title="Avaliação & reavaliação quinzenal"
            desc="Análise periódica de fotos, medidas e desempenho para reajustar treino e dieta a cada 15 dias e garantir evolução contínua."
          />
        </div>
      </div>
    </section>
  );
}
